module.exports = __webpack_public_path__ + "img/home_img_poster.926d85d6.png";